module.exports = __webpack_public_path__ + "static/media/16b.575bc209.jpeg";